var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationStart } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { LanguagePage } from "ocm/src/app/pages";
import { HeaderComponent as SharedHeaderComponent } from "shared/lib/v1/components";
import { SharedRoutes } from "shared/lib/common/enums";
import { RoutingService, TranslateService } from "shared/lib/common/services";
import { ConfigService } from "shared/lib/common/services";
var HISTORY_DISABLED_ROUTES = ["/" + SharedRoutes.admin, "/" + SharedRoutes.configurations];
var HeaderComponent = /** @class */ (function (_super) {
    __extends(HeaderComponent, _super);
    function HeaderComponent(translate, _config, _routing, modal) {
        var _this = _super.call(this, _routing, _config) || this;
        _this.translate = translate;
        _this._config = _config;
        _this._routing = _routing;
        _this.modal = modal;
        _this.history = [];
        _this.pagesWithOutCross = [
            SharedRoutes.screenSaver,
            SharedRoutes.burn,
            SharedRoutes.configurations,
            SharedRoutes.login,
        ];
        _this.languages = {
            de: _this.translate._("GERMAN"),
            en: _this.translate._("ENGLISH"),
        };
        return _this;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._routing.getRouterEvents().subscribe(function (event) {
            var url;
            if (event instanceof NavigationEnd) {
                if (!HISTORY_DISABLED_ROUTES.includes(event.url)) {
                    _this.history.push(event.url);
                    _this.history = _this.history.slice(-2);
                }
            }
            if (event instanceof NavigationEnd || event instanceof NavigationStart || event instanceof NavigationCancel) {
                if (event instanceof NavigationEnd || event instanceof NavigationStart) {
                    url = event instanceof NavigationEnd ? event.urlAfterRedirects : event.url;
                }
                else {
                    url = window.location.pathname;
                }
                _this.showLanguageSelect = url.indexOf("/" + SharedRoutes.screenSaver) >= 0;
                _this.showLogOut = url.indexOf("/" + SharedRoutes.burn) >= 0;
                _this.showCross = !_this.pagesWithOutCross.some(function (page) { return url.includes("/" + page); });
            }
        });
    };
    HeaderComponent.prototype.back = function () {
        this._routing.goForward([this.history.length > 1 ? this.history[0] : SharedRoutes.screenSaver]);
    };
    HeaderComponent.prototype.logOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._routing.goForward([SharedRoutes.screenSaver])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HeaderComponent.prototype.openLanguageModal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var languageModalInputs, languageModal, languageModalData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        languageModalInputs = {
                            selected: this.translate.getSessionLanguage(),
                            languages: [{ key: "de", name: this.translate._("GERMAN") }, { key: "en", name: this.translate._("ENGLISH") }],
                        };
                        return [4 /*yield*/, this.modal.create({
                                component: LanguagePage,
                                componentProps: languageModalInputs,
                                backdropDismiss: false,
                            })];
                    case 1:
                        languageModal = _a.sent();
                        return [4 /*yield*/, languageModal.present()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, languageModal.onDidDismiss()];
                    case 3:
                        languageModalData = _a.sent();
                        this.translate.setSessionLanguage(languageModalData.data);
                        return [2 /*return*/];
                }
            });
        });
    };
    HeaderComponent.prototype.goAdminPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.adminZoneEnabled) return [3 /*break*/, 2];
                        this.adminZoneEnabled = false;
                        return [4 /*yield*/, this._routing.goForward([SharedRoutes.admin])];
                    case 1:
                        _a.sent();
                        this.timeout = setTimeout(function () {
                            _this.adminZoneEnabled = true;
                        }, 500);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return HeaderComponent;
}(SharedHeaderComponent));
export { HeaderComponent };
